<template>
  <div class="wl-program-layout">
    <!-- Oculto por ahora: barra de navegación del módulo (título + tabs)
    <b-card class="wl-program-nav-card border-0 shadow-sm mb-4">...</b-card>
    -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'WeightLossLayout',
}
</script>

<style>
.wl-program-layout {
  padding-top: 0.5rem;
}

.wl-program-layout .card,
.wl-program-layout .card-body {
  overflow: visible !important;
}

/* TitleTable anidado: sin min-height ni borde que recorte labels debajo */
.wl-program-layout .card-header.p-1 {
  display: block !important;
  min-height: 0 !important;
  height: auto !important;
  padding: 0.75rem 0.5rem 1rem !important;
  margin: 0 0 0.25rem !important;
  border: 0 !important;
  border-bottom: none !important;
  background: transparent !important;
  overflow: visible !important;
  line-height: 1.5 !important;
}

.wl-program-layout .card-header.p-1 .card-title {
  display: block !important;
  margin: 0 !important;
  line-height: 1.5 !important;
  overflow: visible !important;
}

.wl-program-layout .card-header.p-1 .card-title i,
.wl-program-layout .card-header.p-1 .card-title span {
  line-height: 1.5 !important;
  vertical-align: middle;
}

/* Filtros: alinear arriba para que labels no se corten */
.wl-program-layout .wl-filters {
  align-items: flex-start !important;
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
  padding-top: 1.25rem !important;
  border-top: 1px solid #ebedf3;
  overflow: visible !important;
}

.wl-program-layout .wl-filters .form-group {
  margin-top: 0 !important;
  margin-bottom: 1rem !important;
  padding-top: 0.15rem;
  overflow: visible !important;
}

.wl-program-layout .wl-filters .form-group > label,
.wl-program-layout .wl-filters label {
  display: block !important;
  position: static !important;
  margin-top: 0 !important;
  margin-bottom: 0.5rem !important;
  padding-top: 0.15rem !important;
  line-height: 1.4 !important;
  overflow: visible !important;
  white-space: normal !important;
  clip: auto !important;
  max-height: none !important;
}
</style>
